import { CONTENT_PROPERTIES_NAMES } from '@lumapps/designer/constants';

export const LOCAL_STORAGE_CONTRIBUTION_MODE_KEY = 'designer-contribution-mode';

export const LOCAL_STORAGE_CONTENT_LANGUAGE_POPOVER = 'designer-content-language-popover';

/** List of settings fields that are not allowed for a user with only writer role */
export const WRITER_ROLE_SETTING_BLACKLIST = [
    CONTENT_PROPERTIES_NAMES.EXTERNAL_LINK,
    CONTENT_PROPERTIES_NAMES.WRITING_ON_BEHALF,
    CONTENT_PROPERTIES_NAMES.EDITORS,
    CONTENT_PROPERTIES_NAMES.NOTIFIED_GROUPS,
    CONTENT_PROPERTIES_NAMES.IS_HOMEPAGE,
    CONTENT_PROPERTIES_NAMES.CONTENT_HTML_ID,
    CONTENT_PROPERTIES_NAMES.CONTENT_HTML_CLASS,
] as const satisfies readonly (typeof CONTENT_PROPERTIES_NAMES)[keyof typeof CONTENT_PROPERTIES_NAMES][];
